import { render, staticRenderFns } from "./BnSideBarNavLink.vue?vue&type=template&id=4a3aa412&scoped=true&"
import script from "./BnSideBarNavLink.vue?vue&type=script&lang=js&"
export * from "./BnSideBarNavLink.vue?vue&type=script&lang=js&"
import style0 from "./BnSideBarNavLink.vue?vue&type=style&index=0&id=4a3aa412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3aa412",
  null
  
)

export default component.exports